export default __webpack_public_path__ + "static/media/VSC.846946a3.png";